import type {
  UseTeamMemberListQueryKeyParams,
  TeamMemberListQueryKey,
} from './types';

export const getTeamMemberListKey = (
  params: UseTeamMemberListQueryKeyParams,
): TeamMemberListQueryKey => ['groups', 'teamMembers', params];
